import { render, staticRenderFns } from "./ClientContacts.vue?vue&type=template&id=80c7aea6&scoped=true"
import script from "./ClientContacts.vue?vue&type=script&lang=js"
export * from "./ClientContacts.vue?vue&type=script&lang=js"
import style0 from "./ClientContacts.vue?vue&type=style&index=0&id=80c7aea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c7aea6",
  null
  
)

export default component.exports